<div *ngIf="report?.calculationFailedAt || report?.renderingFailedAt">
  {{'lang.reporting.generationFailed'|translate}}
</div>
<div *ngIf="!(report?.calculationFailedAt || report?.renderingFailedAt) && !report?.renderingFinishedAt">
  {{'lang.reporting.generatingReports'|translate}} {{'lang.globals.pleaseWait'|translate}}
</div>
<div *ngIf="report?.renderingFinishedAt">
  <div class="row" *ngFor="let file of report?.files">
    <div class="col">
      {{file?.createdAt | date: 'dd.MM.yy HH:mm'}}
    </div>
    <div class="col">
      <a *ngPermissions="permissionService.Permission.device_export"
         (click)="getFile(file)"
         ngbTooltip="{{'lang.globals.download' | translate}}" container="body">
        {{file?.fileName}} ({{util.formatBytes(file?.fileSize)}})
      </a>
    </div>
  </div>
</div>
<!--
<table class="table">
  <thead>
  <tr>
    <th>
      {{'lang.globals.id' | translate}}
    </th>
    <th>
      {{'lang.globals.name' | translate}}
    </th>
    <th>
      {{'lang.globals.createdAt' | translate}}
    </th>
    <th>
      {{'lang.globals.filesize' | translate}}
    </th>
    <th class="tr">
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let file of report?.files">
    <td>
      {{file?.id}}
    </td>
    <td>
      {{file?.fileName}}
    </td>
    <td>
      {{file?.createdAt | date: 'dd.MM.yy HH:mm'}}
    </td>
    <td>
      {{util.formatBytes(file?.fileSize)}}
    </td>
    <td class="tr sticky-col last-col tableBg">
      <sb-table-buttons>
        <a *ngPermissions="permissionService.Permission.device_export"
           class="btn btn-secondary" (click)="getFile(file)"
           ngbTooltip="{{'lang.globals.download' | translate}}" container="body">
          <sb-icon icon="download"></sb-icon>
        </a>
      </sb-table-buttons>
    </td>
  </tr>
  </tbody>
</table>
-->
